import { memo } from 'react';
import { Flex } from '@chakra-ui/react';
import { useThemedStyles } from '../hooks/useThemedStyles';

export const ThemedFlex = memo((props) => {
  const { flexContainer } = useThemedStyles();

  return <Flex {...flexContainer} {...props} />;
});